module.exports = __webpack_public_path__ + "static/media/app-development.a6bd5e20.svg";